import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/common";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const [token, setToken] = useState(sp.get("token") || "");
  const [pw, setPw] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="reset-password-form">
        <h1 className="font-heading text-2xl font-bold">Set a new password</h1>
        <Field label="Reset token"><Input value={token} onChange={(e) => setToken(e.target.value)} data-testid="reset-token-input" required /></Field>
        <Field label="New password (min 8 characters)"><Input type="password" minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" required /></Field>
        <Button className="w-full" data-testid="reset-password-submit-btn">Update password</Button>
      </form>
    </div>
  );
}
